"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement(
      "g",
      { fillRule: "nonzero", fill: "#000" },
      _react2.default.createElement("path", { d: "M2 6h14V4H2zM2 10h14V8H2zM2 14h14v-2H2z" })
    )
  );
};

exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/List.js
// module id = 693
// module chunks = 0